export default {"src":"/_next/static/media/calendar-left-arrow.b23012fd.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};